// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3XDb7","loaderOuter":"PageOverlayLoader_loaderOuter__Dnh19"};